/* ADD GROUPS */
export const REMOVE_GROUP_COURSE = "REMOVE_GROUP_COURSE"
export const REMOVE_GROUP_COURSE_SUCCESS = "REMOVE_GROUP_COURSE_SUCCESS"
export const REMOVE_GROUP_COURSE_CLEAN = "REMOVE_GROUP_COURSE_CLEAN"
export const REMOVE_GROUP_COURSE_ERROR = "REMOVE_GROUP_COURSE_ERROR"
